import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import MusicAppBase from "../components/MusicAppBase";
import Contact from '../components/pages/Contact';
import Home from '../components/pages/home/Home';
import ChartPage from '../components/pages/ChartPage';
import ChartNew from '../components/pages/ChartNew';
import SignInSuccess from '~/shared/session/SignInSuccess';
import ShowAbcApp from '../components/abc/ShowAbcApp';

const FourOhFour = React.lazy(() => import('~/shared/layouts/FourOhFour'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <MusicAppBase />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "charts",
        children: [
          {
            path: ":chartId",
            children: [
              {
                path: ":action",
                element: <ChartPage />
              },
            ]
          },
          {
            path: "new",
            element: <ChartNew />
          },
        ]
      },
      {
        path: "pages",
        children: [
          {
            path: "contact",
            element: <Contact />
          },
        ]
      },
      {
        path: "abc/show",
        element: <ShowAbcApp />
      },
      {
        path: "sessions/sign-in-success",
        element: <SignInSuccess />
      },
    ],
  },
  // routes below here don't get the <MusicAppBase /> layout wrapping
  {
    path: '*',
    element: <FourOhFour />
  }
]);

export default router;